<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { useCustomerStore } from '@entities/customer'
import { useAppBrand } from '@shared/lib/app-brand'

import LinkDisciplineEla from './LinkDisciplineEla.vue'
import LinkDisciplineMath from './LinkDisciplineMath.vue'
import LinkStudentApp from './LinkStudentApp.vue'
import LinkPricing from './LinkPricing.vue'
import BtnSupport from './BtnSupport.vue'
import BtnMore from './BtnMore.vue'

defineOptions({
  name: 'HeaderMenu',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const store = useCustomerStore()

const { isSmartestMinds } = useAppBrand()
</script>

<template>
  <LinkDisciplineMath :layout="layout" />
  <LinkDisciplineEla :layout="layout" />
  <LinkStudentApp
    v-if="!isSmartestMinds"
    :layout="layout"
  />
  <LinkPricing
    v-if="store.isTypeDemo"
    view="menu-button"
    :layout="layout"
  />
  <BtnSupport
    v-else
    :layout="layout"
  />
  <BtnMore :layout="layout" />
</template>
